import { toDateString } from '@seen/core/dates'
import { groupBy, orderBy } from 'lodash-es'
import { useMemo } from 'react'
import type { TimelineItem } from '#src/hooks/useTimelineItems.ts'

export type TimelineListItem =
  | {
      key: string
      type: 'date-group'
      dateString: string
    }
  | {
      key: string
      type: 'item'
      item: TimelineItem
    }

export function useTimelineListItems(
  items: TimelineItem[]
): TimelineListItem[] {
  return useMemo(() => {
    const groupedItems = orderBy(
      Object.entries(groupBy(items, (item) => toDateString(item.date))).map(
        ([dateString, items]) => ({
          dateString,
          items: orderBy(items, [(i) => i.date], ['desc']),
        })
      ),
      [(o) => o.dateString],
      ['desc']
    )
    return groupedItems.flatMap(({ dateString, items }) => [
      {
        key: dateString,
        type: 'date-group' as const,
        dateString,
      },
      ...items.map((item) => ({
        key: item.key,
        type: 'item' as const,
        item,
      })),
    ])
  }, [items])
}

export function estimateTimelineRowHeight(): number {
  return 40
}
